import { ReactComponent as EllipseIcon } from '@assets/images/ellipse.svg'
import { Flex } from 'antd'

import { Tooltip } from '@suntex.fim/ui'

/**
 * returns JSX for hidable text
 */
function HidableText({
  text,
  hidableText
}: {
  text: string | number
  hidableText?: string
}) {
  return (
    <Flex className="HidableText" align="center" justify="center">
      <Tooltip
        title={'' + text}
        key={`${text}+${hidableText}`}
        classNames={{ root: 'progress-tooltip' }}
        arrow={false}
      >
        <b className="HidableText-text" style={{ marginLeft: '4px' }}>
          {text}
        </b>
        <div className="HidableText-ellipse">
          {hidableText?.split('').map((key, index) => (
            <EllipseIcon
              key={key + Number(index)}
              style={{ display: 'inline', marginLeft: '4px' }}
            />
          ))}
        </div>
      </Tooltip>
    </Flex>
  )
}

export default HidableText
